import styled from 'styled-components';

import ErrorIcon from 'assets/images/error.react.svg';
import * as bp from 'view/styles/breakpoints';
import * as fonts from 'view/styles/fonts';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';
import { token } from '@atlaskit/tokens';

export const Root = styled.div`
    ${mixins.borderBox};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    margin-top: ${token('space.400', '32px')};
    margin-bottom: ${grid.multiple(7.4).px};
    padding: 0 ${token('space.400', '32px')};
    width: 100%;

    ${bp.fromSmall.css`
        padding: ${token('space.200', '16px')} 0 0 0;
    `};
`;

export const Icon = styled(ErrorIcon)`
    /* height of icon is not multiple of grid to prevent icon from being warped */
    height: ${grid.multiple(14.375).px};
    width: ${grid.multiple(11).px};
    margin-bottom: ${token('space.200', '16px')};
`;

export const Message = styled.div`
    ${fonts.h600};
    /* setting max-width 100% because on IE, text flows out of the container */
    max-width: 100%;
    margin: 0 0 ${token('space.100', '8px')} 0;
    text-align: center;
`;

export const ContactDescription = styled.p`
    ${fonts.regular};
    /* setting max-width 100% because on IE, text flows out of the container */
    max-width: 100%;
    margin: 0 0 ${token('space.100', '8px')} 0;
    text-align: center;
`;
